"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var emptyImage;
function getEmptyImage() {
    if (!emptyImage) {
        emptyImage = new Image();
        emptyImage.src =
            'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }
    return emptyImage;
}
exports.default = getEmptyImage;



//////////////////
// WEBPACK FOOTER
// ../~/react-dnd-html5-backend/lib/cjs/getEmptyImage.js
// module id = 2785
// module chunks = 1